<template>
  <keep-alive>
    <layout-mobile v-if="isMobileLayout">
      <component v-bind:is="contactComponent"></component>
    </layout-mobile>
    <layout-page v-else>
      <component v-bind:is="contactComponent"></component>
    </layout-page>
  </keep-alive>
</template>

<script>
import ContactsPageDesktop from "./ContactsPageDesktop";
// import ContactsPageMobile from "./ContactsPageMobile";

export default {
  name: "ContactsPage",
  components: {
    ContactsPageDesktop,
    // ContactsPageMobile
  },
  metaInfo: {
    title: "Contacts"
  },
  computed: {
    isMobileLayout() {
      return this.$store.state.isMobile
    },
    contactComponent() {
      // if(this.$store.state.isMobile) {
        // return 'ContactsPageMobile';
      // }
      return 'ContactsPageDesktop';
    }
  }
}
</script>
